// extracted by mini-css-extract-plugin
export default {"tableRow":"tableMps_tableRow__hMPl-","tableItem":"tableMps_tableItem__JbuYA","titleItem":"tableMps_titleItem__7blbN"};